export default __webpack_public_path__ + "static/fonboarding1-4e5522dfa5e9512da878a68f8306906d.jpg";